import './CeoMsg.css'
import TriangularUp from "../../../assets/triangular/transition-triangular-top.svg";
import ComasIcon from "../../../assets/icons/comas.svg";

export default function CeoMsg() {

    return (
        <div>
            <section className="ceo-msg">
                <img
                    src={TriangularUp}
                    alt="background grey triangular"
                    width="100%"
                    style={{alignSelf: 'stretch'}}
                />
                <div className="ceo-msg-container">
                    <div className="ceo-msg-content">
                        <div className='ceo-msg-box'>
                            <div className='ceo-msg-text-container'>
                                <div style={{
                                    alignSelf: 'stretch',
                                    color: '#CBD5E1',
                                    fontSize: '18px',
                                    fontWeight: '600',
                                    wordWrap: 'break-word',
                                    textAlign: 'left'
                                }}>
                                    “Our feedback used to be scattered all over the place. Nobody had the full picture,
                                    and most of the feedback was inside someone's head. With Magic Feedback, we got
                                    everything into one place and took control of our feedback. It has allowed me to
                                    explain exactly what users want, and the user stories help engineers understand
                                    exactly what to build.”
                                </div>
                            </div>
                        </div>
                        <div style={{
                            justifyContent: 'flex-start',
                            alignItems: 'center',
                            gap: '32px',
                            display: 'inline-flex',
                            marginBottom: '74px',
                            marginTop: '24px'
                        }}>
                            <div style={{
                                minWidth: '48px',
                                minHeight: '48px',
                                background: '#64748B',
                                borderRadius: 100,
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center',
                                display: 'inline-flex'
                            }}>
                                <img src={ComasIcon}
                                     alt="comas"
                                     style={{width: '24px', height: '24px'}}
                                />
                            </div>
                            <div
                                className='ceo-msg-name'>
                                -Maria Westergaard, CEO, Hint
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}
